/* eslint-disable */
const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_lWvtissB0",
    "aws_user_pools_web_client_id": "3bdkcrgviebaiknsjiv1vg0q18",
    "aws_cognito_identity_pool_id": "us-east-1:7bfce333-094f-465b-a1b2-bfa7c77c5cc6",
    "oauth": {
        "domain": "auth.staging.aklor.org",
        "responseType": "code"
    },
    "aws_cognito_username_attributes": [
        "USERNAME"
    ],
    "aws_cognito_mfa_configuration": "ON",
    "aws_cognito_mfa_types": [
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 15,
        "passwordPolicyCharacters": [
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};

// TODO: setup the production version of this and un-symlink.

export default awsmobile;
